import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=a27c48ce&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a27c48ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a27c48ce')) {
      api.createRecord('a27c48ce', component.options)
    } else {
      api.reload('a27c48ce', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=a27c48ce&scoped=true&", function () {
      api.rerender('a27c48ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2yBK0HhbOvTu0/JS/comp/SearchFilterTokens.vue"
export default component.exports